import { useState } from 'react';
import { ContactModel } from '../models/contactModel';

export function useContactController() {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (formData) => {
    setSubmitting(true);
    try {
      await ContactModel.submit(formData);
      setStatus('SENT');
    } catch (e) {
      setError(e);
    } finally {
      setSubmitting(false);
    }
  };

  return { submit, status, submitting, error };
}
